import { Injectable } from '@angular/core'

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuItemSource = new BehaviorSubject<boolean>(false);
  menuItem = this.menuItemSource.asObservable();

  changeVisibility(showMenu: boolean) {
    this.menuItemSource.next(showMenu);
  }
}
